const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}

if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const originalSubmit = document.querySelector('.product-selector__submit');
        if (!originalSubmit) return;

        const stickySubmit = this.querySelector('.product-selector__submit');
        if (!stickySubmit) return;

        const productGallery = document.querySelector('.product__media');

        const hasVariants = this.dataset.hasVariants === 'true';
        const selectorTarget = this.dataset.selectorTarget;

        let isSubmitVisible = false;
        let isGalleryVisible = false;
        let hasUserSelectedVariant = false;

        /* Track whether the customer has explicitly interacted with the
           size picker. Covers Shopify's standard variant-picker patterns:
           radio inputs, <select> dropdowns, and the hidden input[name="id"]
           that all variant pickers update on change. */
        if (hasVariants) {
          /* In the Sahara theme, the variant picker is a <product-selector> custom element
             that lives OUTSIDE of <product-form>. Its ID matches the selectorTarget attribute,
             so we use that to find it. We also listen on document as a safety net. */
          const variantPicker = selectorTarget ? document.querySelector(selectorTarget) : null;
          const listenTarget = variantPicker || document;

          listenTarget.addEventListener('change', (e) => {
            if (e.target.matches('input[type="radio"], select, input[name="id"]')) {
              hasUserSelectedVariant = true;
            }
          });

          listenTarget.addEventListener('click', (e) => {
            /* catch swatch buttons/labels */
            if (e.target.closest('[data-variant-option], .variant-option, label')) {
              hasUserSelectedVariant = true;
            }
          });
        }

        stickySubmit.addEventListener('click', (e) => {
          if (hasVariants && !hasUserSelectedVariant) {
            e.preventDefault();
            const target = selectorTarget ? document.querySelector(selectorTarget) : null;
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
              target.classList.add('sticky-atc-highlight');
              setTimeout(() => target.classList.remove('sticky-atc-highlight'), 1200);
            }
          }
          /* else: a size has already been chosen (or none was needed) —
             let the native form submission proceed and add to cart */
        });

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.target === originalSubmit) isSubmitVisible = entry.isIntersecting;
              if (entry.target === productGallery) isGalleryVisible = entry.isIntersecting;
            });

            stickySubmit.style.display = (isSubmitVisible || isGalleryVisible) ? 'none' : '';
          },
          { threshold: 0.01 }
        );

        observer.observe(originalSubmit);
        if (productGallery) observer.observe(productGallery);
      }
    }
  );
}
